import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ContractActionName } from 'api/endpoints/contractActionNames';
import { FetchStatus } from 'types/fetch-status.types';

export type ActionNamesSlice = {
  contractsData: ContractActionName[] | null;
  contractsStatus: FetchStatus;
  error: { message: string } | null;
};

export const initialState: ActionNamesSlice = {
  contractsData: null,
  contractsStatus: FetchStatus.Idle,
  error: null,
};

const actionNamesSlice = createSlice({
  name: 'action-names',
  initialState: initialState,
  reducers: {
    setActionNamesFetchingIdle(state: ActionNamesSlice) {
      state.contractsStatus = FetchStatus.Idle;
    },
    contractActionNamesFetching(state: ActionNamesSlice) {
      state.contractsStatus = FetchStatus.Fetching;
    },
    contractActionNamesDone(
      state: ActionNamesSlice,
      action: PayloadAction<ContractActionName[]>,
    ) {
      state.contractsData = action.payload;
      state.contractsStatus = FetchStatus.Done;
    },
    contractActionNameCreated(
      state: ActionNamesSlice,
      action: PayloadAction<ContractActionName>,
    ) {
      state.contractsStatus = FetchStatus.Done;
      if (state.contractsData) {
        state.contractsData = [action.payload, ...state.contractsData];
      }
    },
    contractActionNameEdit(
      state: ActionNamesSlice,
      action: PayloadAction<ContractActionName>,
    ) {
      state.contractsStatus = FetchStatus.Done;
      if (state.contractsData) {
        const index = state.contractsData.findIndex(
          (a) => a.id === action.payload.id,
        );
        if (index > -1) {
          state.contractsData[index] = action.payload;
        }
      }
    },
    actionNamesError(
      state: ActionNamesSlice,
      action: PayloadAction<{ message: string }>,
    ) {
      state.contractsStatus = FetchStatus.Error;
      state.error = action.payload;
    },
  },
});

export const {
  actionNamesError,
  contractActionNamesFetching,
  contractActionNamesDone,
  contractActionNameCreated,
  contractActionNameEdit,
  setActionNamesFetchingIdle,
} = actionNamesSlice.actions;
export default actionNamesSlice.reducer;
